module.exports = __webpack_public_path__ + "media/NewOrder.2a6da04d.mp3";